import { useState, useEffect, useContext, useRef } from 'react';

import { SaleListContext } from '../SaleListContext';
import { SaleLabel } from '../label/SaleLabel';
import { SaleListItemInfo } from './info/SaleListItemInfo';

export function SaleListItem(props: any) {
  const sale = props.sale;

  const setDetailSale = useContext(SaleListContext).setDetailSale;

  const onPress = () => {
    if(sale) {
      setDetailSale(sale);
    }
  }


  return (
    <>
    {sale &&
      <div
        style={{
          height: '100%',
          width: '100%',
          flex: 1,
          marginBottom: window.innerHeight * 0.03,
        }}
        onClick={onPress}
      >

        {/* サムネイル */}
        {sale.movie_thumb &&
          <img
            src={`/images/sale/thumb/${sale.movie_thumb}`}
            className="img-thumbnail"
            style={{width: '100%', objectFit: 'cover'}}
            loading="lazy"
          />
        }

        {/* 情報 */}
        <div style={{padding: '3px 5px'}}>
          {/* 各種ラベル */}
          <SaleLabel sale={sale} />

          {/* 動画情報 */}
          <SaleListItemInfo sale={sale} />
        </div>

      </div>
    }
    </>
  );
}